import { render, staticRenderFns } from "./ModelModalTitle.vue?vue&type=template&id=512dfd63&"
import script from "./ModelModalTitle.vue?vue&type=script&lang=js&"
export * from "./ModelModalTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports